import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../Users/hooks/useAuth";
import CommunityCommentsBrowser from "../components/SnapsWise/comments/CommunityCommentsBrowser";

export default function CommunityPage() {
  const { auth } = useAuth();
  const navigate = useNavigate();

  const resolvedAuth = useMemo(() => {
    const username =
      auth?.username ||
      auth?.user?.username ||
      auth?.currentUser?.username ||
      localStorage.getItem("username") ||
      null;

    const userId =
      auth?.userId ||
      auth?.id ||
      auth?._id ||
      auth?.user?.id ||
      auth?.user?._id ||
      auth?.currentUser?.id ||
      auth?.currentUser?._id ||
      localStorage.getItem("userId") ||
      null;

    return {
      ...auth,
      username,
      userId,
    };
  }, [auth]);

  return (
    <CommunityCommentsBrowser
      auth={resolvedAuth}
      successHandler={() => navigate("/")}
    />
  );
}